import React, { useEffect } from "react";
import Button from "../Utility/Button";
import "./LandingPage.css";
import LandingImage from "./Artboard – 3.png";
import LandingSmall from "./Artboard – 4.png";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth } from "../authContext"

export default function () {
  // let data;
  const { currentUser } = useAuth()
//   useEffect(()=>{
// data = 
//   },[])

  return (
    <div className="landingpagecontainer">
      <img src={LandingImage} alt="landing" className="landingimage" />

      <div className="landingpagebar">
        <h3 className="landingpagetext">Always At Ur Service</h3>
        <article>
          We are giving a single platform for doctors of your appliances and
          making your headache of searching for them easier.
        </article>
        <div className="landingpageinnerbar">
          {!currentUser && (
            <Button className="landingpagerequest" background={"#fa824c"}>
              <Link to={"/register"}>Register</Link>
            </Button>
          )}
        </div>
      </div>
      <img src={LandingSmall} alt={"landing page"} className={"landingsmall"} />
    </div>
  );
}
